/**
 * @desc getPoSkuBindSnInfo
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierSnSearch.getPoSkuBindSnInfo.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierSn/getPoSkuBindSnInfo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
